import i18n from '@/i18n'
import { success, danger } from '@/lib/notification'

export const notificationSuccessfully = (operation) => {
    const item = i18n.tc('enps.researches', 1)
    if (operation === 'create') {
        return success(
            i18n.t('notification.createdSuccessfully', {
                item,
            })
        )
    }
    if (operation === 'duplicate') {
        return success(
            i18n.t('notification.duplicatedSuccessfully', {
                item,
            })
        )
    }
    if (operation === 'update') {
        return success(
            i18n.t('notification.editedSuccessfully', {
                item,
            })
        )
    }
    if (operation === 'apply') {
        return success(
            i18n.t('notification.appliedSuccessfully', {
                item,
            })
        )
    }
    if (operation === 'close') {
        return success(
            i18n.t('notification.closedSuccessfully', {
                item,
            })
        )
    }
    if (operation === 'create-apply') {
        return success(
            i18n.t('notification.createdAndAppliedSuccessfully', {
                item,
            })
        )
    }
    return success(
        i18n.t('notification.deletedSuccessfully', {
            item,
        })
    )
}

export const notificationError = () => {
    danger()
}
